var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEquipmentUnPinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7729 3.49573C12.7729 1.27672 10.212 0.165438 8.71422 1.73451L1.70113 9.08154C0.203371 10.6506 1.26414 13.3335 3.38229 13.3335C4.01285 13.3335 4.61758 13.5959 5.06345 14.063L7.03306 16.1264C7.47893 16.5935 7.72942 17.227 7.72942 17.8876C7.72942 20.1066 10.2903 21.2179 11.7881 19.6488L18.8012 12.3018C20.2989 10.7327 19.2382 8.04985 17.12 8.04985C16.4895 8.04985 15.8847 7.78743 15.4389 7.32033L13.4693 5.25694C13.0234 4.78984 12.7729 4.15631 12.7729 3.49573Z",
    fill: "#E4E7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6006 16.2958L22 23M7.03306 16.1264L5.06345 14.063C4.61758 13.5959 4.01285 13.3335 3.38229 13.3335C1.26414 13.3335 0.203371 10.6506 1.70113 9.08154L8.71422 1.73451C10.212 0.165438 12.7729 1.27672 12.7729 3.49573C12.7729 4.15631 13.0234 4.78984 13.4693 5.25694L15.4389 7.32033C15.8847 7.78743 16.4895 8.04985 17.12 8.04985C19.2382 8.04985 20.2989 10.7327 18.8012 12.3018L11.7881 19.6488C10.2903 21.2179 7.72942 20.1066 7.72942 17.8876C7.72942 17.227 7.47893 16.5935 7.03306 16.1264Z",
    stroke: "#979797",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentUnPinIcon);
export default __webpack_public_path__ + "static/media/EquipmentUnPinIcon.b7ab10bf.svg";
export { ForwardRef as ReactComponent };